const IOS_APP_CLIP_FOREGROUND = '0079ff';
const IOS_APP_CLIP_LIGHT_BACKGROUND = 'ffffff';
const IOS_APP_CLIP_DARK_BACKGROUND = '212529';
let generatePromise;

async function getGenerate() {
  if (!generatePromise) {
    generatePromise = import('appclipcode')
      .then(({ generate }) => generate)
      .catch((error) => {
        generatePromise = null;
        throw error;
      });
  }

  return generatePromise;
}

export function getIosAppClipCodePayloadUrl(profile) {
  return `https://app.nextdns.io/${encodeURIComponent(profile)}`;
}

export default async function getIosAppClipCodeSrc(profile, theme) {
  const background = theme === 'dark' ? IOS_APP_CLIP_DARK_BACKGROUND : IOS_APP_CLIP_LIGHT_BACKGROUND;
  const generate = await getGenerate();
  const svg = generate(getIosAppClipCodePayloadUrl(profile), IOS_APP_CLIP_FOREGROUND, background);
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
